<script>
    export let dialogMessage;
    export let dialogType;
</script>

<div class="alert {dialogType}" role="alert">
    { dialogMessage }
</div>
